import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { environment } from 'src/environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private bsModalRef: BsModalRef;

  constructor(private http: HttpClient,private modalService: BsModalService) { }

  register(data: any){
    return this.http.post(environment.apiUrl+'register', data).pipe(response => response);
  }

  changePassword(data: any){
    return this.http.post(environment.apiUrl+'change-password', data).pipe(response => response);
  }
  saveDemande(data: any,url?){
    url = url || 'ajout-demande';
    return this.http.post(environment.apiUrl+url, data).pipe(response => response);
  }
  saveSinistre(data: any){
    return this.http.post(environment.apiUrl+'sinistres', data).pipe(response => response);
  }
  savePlainte(data: any){
    return this.http.post(environment.apiUrl+'plaintes', data).pipe(response => response);
  }
  saveRappel(data: any){
    return this.http.post(environment.apiUrl+'rappels', data).pipe(response => response);
  }
  saveLetter(data: any){
    return this.http.post(environment.apiUrl+'lettres', data).pipe(response => response);
  }
  saveFile(data: any){
    return this.http.post(environment.apiUrl+'upload', data).pipe(response => response);
  }
  storeFile(data: any){
    return this.http.post(environment.apiUrl+'store-file', data).pipe(response => response);
  }
  checkSinistre(data: any){
    return this.http.post(environment.apiUrl+'check-sinistre', data).pipe(response => response);
  }
  getDevis(data: any){
    return this.http.post(environment.apiUrl+'simulate-auto', data).pipe(response => response);
  }
  getDevisVoyage(data: any){
    return this.http.post(environment.apiUrl+'get-devis-voyage', data).pipe(response => response);
  }
  activateAccount(key: string){
    return this.http.get(environment.apiUrl+'activate?key='+key).pipe(response => response);
  }

  getProduits(){
    return this.http.get(environment.apiUrl + 'produits')
    .pipe(response => response);
  }
  getMarques(){
    return this.http.get(environment.apiUrl + 'marque-model?max=100000000&offset=0')
    .pipe(response => response);
  }
  getPays(){
    return this.http.get(environment.apiUrl + 'pays?max=100000000&offset=0')
    .pipe(response => response);
  }
  getAssureurs(){
    return this.http.get(environment.apiUrl + 'assureurs?max=100000000&offset=0')
    .pipe(response => response);
  }
  getCategories(){
    return this.http.get(environment.apiUrl + 'categorie-vehicule?max=100000000&offset=0')
    .pipe(response => response);
  }
  getGarantieVoyage(data){
    return this.http.post(environment.apiUrl + 'get-garantie-voyage-by-filiale?max=100000000&offset=0',data)
    .pipe(response => response);
  }
  getModels(data){
    return this.http.post(environment.apiUrl + 'get-all-modeles-by-marque',data)
    .pipe(response => response);
  }
  getGaranties(data){
    return this.http.post(environment.apiUrl + 'get-all-garanties',data)
    .pipe(response => response);
  }
  getSinistre(){
    return this.http.get(environment.apiUrl + 'type-sinistres'+'?max=100' +'&offset=0')
    .pipe(response => response);
  }

// new
  getModel(){
    return this.http.get(environment.apiUrl + 'vehicle-model/get-make')
    .pipe(response => response);
  }

  getTransportPublicType() {
    return this.http.get(environment.apiUrl + 'types-vehicule?max=100&offset=0').pipe(response => response);
}

getTypeGaranties () {
  return this.http.get(environment.apiUrl + 'type-garantie/list-garanties'+'?max='+100 +'&offset=' +0).pipe(response => response);
}

login(body){
  return this.http.post(environment.apiUrl + 'login', body).pipe(response => response);
}

autoLogin() {
  return this.http.post(environment.apiUrl + 'auto-login', {}).pipe(response => response);
}


}
